import { initializeApp, getApps } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore, DocumentReference, DocumentData, SetOptions } from 'firebase/firestore'
import { getAnalytics } from 'firebase/analytics'
import { getRemoteConfig, fetchAndActivate } from 'firebase/remote-config'

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID
}

// Initialize Firebase
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0]
const auth = getAuth(app)
const db = getFirestore(app)

// nalytics (only client‑side)
const analytics =
  typeof window !== 'undefined'
    ? getAnalytics(app)
    : null

// Remote Config with defaults
const remoteConfig = getRemoteConfig(app)
remoteConfig.settings = {
  // in dev you can lower this, in prod keep default (12h)
  minimumFetchIntervalMillis: 3600 * 1000, 
}
remoteConfig.defaultConfig = {
  // your experiment flag key & default value
  show_discount_variant: 'false',
}

// Optional helper to fetch and activate the latest values
export async function activateRemoteConfig() {
  try {
    await fetchAndActivate(remoteConfig)
  } catch (e) {
    console.warn('Remote Config fetch failed:', e)
  }
}

export { app, auth, db, analytics, remoteConfig }

// Wrapper function for Firestore write operations
export async function loggedSetDoc(
  docRef: DocumentReference<DocumentData>,
  data: DocumentData,
  options?: SetOptions
) {
  const { setDoc } = await import('firebase/firestore')
  return setDoc(docRef, data, options)
}

// Wrapper function for Firestore read operations
export async function loggedGetDoc(docRef: DocumentReference<DocumentData>): Promise<DocumentData | undefined> {
  const { getDoc } = await import('firebase/firestore')
  const docSnap = await getDoc(docRef)
  return docSnap.data()
}